import styled from 'styled-components'
import { SkeletonElement, theme } from '@notino/react-styleguide'

// styles
import { BREAKPOINTS } from '../../../../styles/constants'

export const PassCardLink = styled.a<{ $isPast?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
	border-radius: 8px;
	background-color: ${theme.color.common.red99};
	text-decoration: none;
	color: inherit;
	opacity: ${({ $isPast }) => ($isPast ? 0.6 : 1)};
`

export const PassCardHeader = styled.div`
	display: flex;
	flex-direction: column;
`

export const ServiceName = styled.h3`
	margin: 0;
	${theme.typography.titleMedium};
	color: ${theme.color.text.primary};

	@media (min-width: ${BREAKPOINTS.sm}) {
		line-height: 2rem;
	}
`

export const SalonName = styled.p`
	margin: 0;
	${theme.typography.labelRegular400};
	color: ${theme.color.text.secondary};
`

export const PassCardFooter = styled.div`
	display: flex;
	gap: 20px;
`

export const PassCardFooterColumn = styled.div<{ $align?: 'left' | 'right' }>`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: ${({ $align = 'left' }) => ($align === 'right' ? 'flex-end' : 'flex-start')};
`

export const PassCardLabel = styled.p`
	margin: 0;
	${theme.typography.labelRegular400};
	color: ${theme.color.text.secondary};
`

export const PassCardValue = styled.p`
	margin: 0;
	${theme.typography.labelLarge400};
	line-height: 1.5rem;
	color: ${theme.color.text.primary};
`

export const PassCardSkeleton = styled(SkeletonElement)`
	border-radius: 8px;
`

export const PassesGrid = styled.div`
	display: grid;
	gap: 20px;

	@media (min-width: ${BREAKPOINTS.sm}) {
		grid-template-columns: 1fr 1fr;
	}

	@media (min-width: ${BREAKPOINTS.lg}) {
		gap: 40px;
	}
`

export const BottomNavigation = styled.nav`
	position: relative;
	margin-top: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 48px;
`

export const PaginationWrapper = styled.div`
	display: none;

	@media (min-width: ${BREAKPOINTS.lg}) {
		display: block;
		position: absolute;
		right: 0;
	}
`
